import React, { useState, useEffect, useRef } from "react";
import apiService from "../config";
import { useLanguage } from '../StoreContext/LanguageContext';
import { X } from "lucide-react";

const SubShakshepAdhikari = ({ fetchButtonStatus }) => {
  const [isEditing, setIsEditing] = useState(false);
  const { language, translations } = useLanguage();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [showSendToProjectInchargeModal, setShowSendToProjectInchargeModal] = useState(false);
  const [usersProjectIncharge, setUsersProjectIncharge] = useState([]);
  const [loadingUsersProjectIncharge, setLoadingUsersProjectIncharge] = useState(false);
  const [selectedUserProjectIncharge, setSelectedUserProjectIncharge] = useState('');
  const [remarksProjectIncharge, setRemarksProjectIncharge] = useState('');
  const [selectedDocumentProjectIncharge, setSelectedDocumentProjectIncharge] = useState(null);
  const [sendingToProjectIncharge, setSendingToProjectIncharge] = useState(false);
  const [projectId, setProjectId] = useState(null);
  const [proposalId, setProposalId] = useState(null);

  // Project Id
  useEffect(() => {
    const getProjectInfo = () => {
      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name
          };
        } catch (e) {
          console.error('Error parsing selected project (selectedProject):', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          const projectId = user.data?.project_id || user.project_id;
          const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
          return {
            id: projectId,
            name: projectName
          };
        } catch (e) {
          console.error('Error parsing user data (userData):', e);
        }
      }
      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setProjectId(projectInfo.id);
    console.log('Current Project Info:', projectInfo);
  }, []);

  // Proposal id
  useEffect(() => {
    const getProposalInfo = () => {
      const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

      if (currentProposal) {
        try {
          return {
            proposalId: currentProposal?.data?.default_proposal ||
              currentProposal?.data?.proposal_id ||
              currentProposal?.default_proposal ||
              currentProposal?.proposal_id ||
              null
          }
        } catch (e) {
          console.error('Error parsing current project data (getProposalInfo):', e);
        }
      }
      return { proposalId: null };
    };

    const proposalInfo = getProposalInfo();
    setProposalId(proposalInfo.proposalId);
    console.log('Current Project-Proposal Info:', proposalInfo);
  }, []);

  const fetchUsersProjectIncharge = async () => {
    const role = 18;
    setLoadingUsersProjectIncharge(true);
    try {
      const response = await apiService.getAllUserRoleProjectIncharge(
        role,
        projectId,
        proposalId
      );

      if (response.status === 200 && response.data) {
        setUsersProjectIncharge(Array.isArray(response.data) ? response.data : []);
      } else {
        setUsersProjectIncharge([]);
      }
    } catch (error) {
      console.error('Error fetching Project Incharge users:', error);
      setUsersProjectIncharge([]);
    } finally {
      setLoadingUsersProjectIncharge(false);
    }
  };

  useEffect(() => {
    if (showSendToProjectInchargeModal) {
      fetchUsersProjectIncharge();
    }
  }, [showSendToProjectInchargeModal]);

  const handleSendToProjectIncharge = async () => {
    if (!selectedUserProjectIncharge || !selectedDocumentProjectIncharge) {
      alert('Please select user and upload document');
      return;
    }

    if (!projectId || !proposalId) {
      alert('Project ID and Proposal ID are required');
      return;
    }

    setSendingToProjectIncharge(true);

    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarksProjectIncharge);
      formData.append('usr_id', selectedUserProjectIncharge);
      formData.append('document', selectedDocumentProjectIncharge);

      const response = await apiService.postTrackingSendToProjectIncharge(formData);

      if (response.status === 200) {
        alert('Successfully sent to Project Incharge');
        setShowSendToProjectInchargeModal(false);
        setSelectedUserProjectIncharge('');
        setRemarksProjectIncharge('');
        setSelectedDocumentProjectIncharge(null);
        fetchButtonStatus();
      } else {
        alert('Failed to send to Project Incharge');
      }
    } catch (error) {
      console.error(error);
      alert('Failed to send to Project Incharge');
    } finally {
      setSendingToProjectIncharge(false);
    }
  };

  // Add this inside Section3A component, before the return statement
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
    @media print {
      body * {
        visibility: hidden;
      }
      .print-container,
      .print-container * {
        visibility: visible;
      }
      .print-container {
        position: absolute;
        left: 0;
        top: 0;
      }
      .print:hidden {
        display: none !important;
      }
      @page {
        size: A4;
        margin: 0;
      }
    }
  `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const handlePrintView = () => {
    window.print();
  };

  const handleSubmit = () => {
  };

  const Section3AEditModal = ({ onClose }) => {
    return (
      <div className="fixed inset-0 z-50 bg-black/40 flex justify-center items-center p-4">
        <div className="bg-white w-full max-w-5xl rounded-2xl shadow-xl overflow-hidden">

          {/* HEADER */}
          <div className="flex justify-between items-center px-6 py-4 border-b">
            <h2 className="text-2xl font-bold text-gray-800">
              Section 3A
            </h2>
            <button onClick={onClose}>
              <X size={24} />
            </button>
          </div>

          {/* BADGE */}
          <div className="flex justify-center mt-4">
            <span className="px-6 py-2 bg-blue-600 text-white rounded-full font-semibold">
              भूमिसंपादन प्रकरण तपशील
            </span>
          </div>

          {/* FORM */}
          <div className="p-6 grid grid-cols-1 md:grid-cols-4 gap-4">

            <Input label="दिनांक" type="date" />
            <Input label="Highway No." placeholder="Enter Highway No" />
            <Input label="District" placeholder="Enter District" />
            <Input label="State" placeholder="Enter State" />

            <Input label="Km From" placeholder="Km Start" />
            <Input label="Km To" placeholder="Km End" />
            <Input label="Section Name" placeholder="Enter Section Name" />
            <Input label="Notification No." placeholder="Enter Notification No" />
          </div>

          {/* PART ONE */}
          <div className="flex justify-center my-4">
            <span className="px-6 py-2 bg-blue-600 text-white rounded-full font-semibold">
              भाग - एक
            </span>
          </div>

          {/* PARAGRAPH */}
          <div className="px-6">
            <label className="block font-semibold mb-1">तपशील:</label>
            <textarea
              rows={6}
              className="w-full border rounded-lg p-3"
              placeholder="Enter notification details..."
            />
          </div>

          {/* TABLE */}
          <div className="px-6 mt-6 overflow-x-auto">
            <table className="w-full border text-sm">
              <thead className="bg-gray-100">
                <tr>
                  {[
                    "Sr",
                    "District",
                    "Taluka",
                    "Village",
                    "Survey No",
                    "Type",
                    "Nature",
                    "Area",
                    "Total Area",
                  ].map(h => (
                    <th key={h} className="border px-2 py-2">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[1, 2].map(i => (
                  <tr key={i}>
                    {Array(9).fill("").map((_, j) => (
                      <td key={j} className="border p-1">
                        <input
                          className="w-full outline-none"
                          placeholder="—"
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* FOOTER */}
          <div className="flex justify-end gap-4 px-6 py-4 border-t mt-6">
            <button
              onClick={onClose}
              className="px-6 py-2 border rounded-lg"
            >
              Cancel
            </button>
            <button className="px-8 py-2 bg-blue-600 text-white rounded-lg">
              Save
            </button>
          </div>
        </div>
      </div>
    );
  };

  const Input = ({ label, type = "text", placeholder }) => {
    return (
      <div>
        <label className="block font-semibold mb-1">{label}</label>
        <input
          type={type}
          placeholder={placeholder}
          className="w-full border rounded-lg px-3 py-2"
        />
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-400 py-8 flex flex-col items-center gap-8">

      {isEditOpen && (
        <Section3AEditModal onClose={() => setIsEditOpen(false)} />
      )}

      <div className="print-container">
        {/* TOP RIGHT ACTIONS - Fixed position */}
        <div className="flex justify-end gap-4 mb-4 print:hidden">
          {/* print */}
          <button
            type="button"
            onClick={handlePrintView}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
          >
            {translations[language]?.Print}
          </button>
          {/* Edit Button */}
          <button
            onClick={() => setIsEditOpen(true)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            {translations[language]?.edit}
          </button>

          {/* Send to Project Incharge Button */}
          <button
            onClick={() => setShowSendToProjectInchargeModal(true)}
            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
          >
            {translations[language]?.SendToProjectIncharge}
          </button>
        </div>

        {/* ========== ENGLISH PAGE 1 ========== */}
        <div className="bg-white w-[794px] min-h-[1123px] p-[60px] font-serif text-[14px] leading-[1.8] text-black">

          <p className="text-center font-semibold uppercase">
            [TO BE PUBLISHED IN THE GAZETTE OF INDIA,
            <p className="text-center font-bold">
              EXTRAORDINARY PART-II, SECTION 3, SUB SECTION (ii)]
            </p>
          </p>

          <p className="text-center font-bold">GOVERNMENT OF INDIA</p>
          <p className="text-center font-semibold">
            MINISTRY OF SHIPPING, ROAD TRANSPORT AND HIGHWAYS
          </p>
          <p className="text-center text-sm">
            (Department of Road Transport and Highways)
          </p>

          <p className="text-center font-bold mt-8">NOTIFICATION</p>

          <p className="text-right mt-4">
            NEW DELHI , Dated the ............ 2024
          </p>

          <p className="mt-8 text-justify indent-8">
            S.O. ......... (E).- In exercise of the powers conferred by clause (a) of
            section 3 of the National Highways Act, 1956 (48 of 1956), the Central
            Government hereby authorizes the officers mentioned in column (2) of the
            Schedule annexed hereto as the competent authorities to perform the
            functions of such authorities under the said Act with effect from the date
            of publication of this notification in the Official Gazette, in respect of
            the stretch of land specified in the corresponding entry in column (3) of
            the said Schedule relating to districts, Taluk, police station and villages
            mentioned in column (4), (5), (6) and (7) respectively of the said Schedule
            for (widening two laning, etc.), maintenance, management and operation of the
            NH-161G – Shegaon to MP Border Road (NH-161G) From Km. 55/000 To 118/000 in
            District Buldhana, in the State of Maharashtra on EPC Mode.
          </p>
          <p className="text-center font-bold">SCHEDULE</p>

          <p className="mt-4 text-center font-semibold">
            Land Acquisition National Highway NH-161G – Shegaon to MP Border Road (NH-161G)
            <br />
            From Km. 55/000 To 118/000 in District Buldhana in the State of Maharashtra
          </p>

          <table className="w-full border border-black mt-6 text-[12px]">
            <thead>
              <tr>
                {[
                  "Sr. No.",
                  "Competent Authority",
                  "Stretch of Land",
                  "District",
                  "Taluka",
                  "Police Station",
                  "Name of Village",
                ].map(h => (
                  <th key={h} className="border border-black px-2 py-2 text-center">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border text-center">1</td>
                <td className="border text-center">
                  Deputy Collector, Land Acquisition, Buldhana
                </td>
                <td className="border text-center">
                  From Km 55/000 to 118/000
                </td>
                <td className="border text-center">Buldhana</td>
                <td className="border text-center">Sangrampur</td>
                <td className="border text-center">Sangrampur</td>
                <td className="border text-center">Warwat Khanderao</td>
              </tr>
            </tbody>
          </table>

          <div className="flex justify-between mt-12 text-sm">
            <div>
              <p>Deputy Collector,</p>
              <p>Land Acquisition,</p>
              <p>Buldhana.</p>
            </div>

            <div className="text-right">
              <p>Executive Engineer</p>
              <p>National Highway Division,</p>
              <p>Akola.</p>
            </div>
          </div>

          <p className="text-right mt-10 text-sm">
            (File No...................)
          </p>

          <p className="text-right mt-6 text-sm">
            Deputy Secretary to the Government of India
          </p>
        </div>
        {/* ================= MARATHI PAGE 1 ================= */}
        <div className="bg-white w-[794px] min-h-[1123px] p-[60px] font-serif text-[14px] leading-[1.9] text-black">

          <p className="text-center font-semibold">
            [भारत के राजपत्र, असाधारण<br />
            भाग 2 – खण्ड 3 – उप-खण्ड (2) में]
          </p>
          <p className="text-center font-bold">प्रकाशनार्थ भारत सरकार</p>
          <p className="text-center font-semibold">
            सड़क परिवहन और राजमार्ग मंत्रालय
          </p>

          <p className="text-center font-bold mt-2">अधिसूचना</p>

          <p className="text-right mt-4">
            नई दिल्ली, ________ 2025
          </p>

          <p className="mt-8 text-justify indent-8">
            का.आ. (अ).- केंद्रीय सरकार, राष्ट्रीय राजमार्ग अधिनियम, 1956
            (1956 का 48) की धारा 3 के खण्ड (क) द्वारा प्रदत्त शक्तियों का प्रयोग करते हुए,
            महाराष्ट्र राज्य के बुलढाणा जिले में शेगांव से एम.पी. बॉर्डर रोड
            राष्ट्रीय महामार्ग संख्या 161G के निर्माण (चौड़ा करने, दो लेन पक्के शोल्डर
            बनाने, आदि), अनुरक्षण, प्रबंध और प्रचालन के लिये उक्त अनुसूची के स्तंभ
            (4), (5), (6) और स्तंभ (7) में क्रमशः उल्लिखित जिलों, तालुकों,
            पुलिस थानों और गांवों से संबंधित उक्त अनुसूची के स्तंभ (3) की तत्स्थानी
            प्रविष्टि में विनिर्दिष्ट भूखंड के संबंध में इस अधिसूचना के राजपत्र में
            प्रकाशन की तारीख से अनुसूची के स्तंभ (2) में उल्लिखित अधिकारियों को
            उक्त अधिनियम के अधीन सक्षम प्राधिकारी के कृत्यों का पालन करने के लिये
            सक्षम प्राधिकारी के रूप में प्राधिकृत करती है।
          </p>
          <p className="text-center font-bold">अनुसूची</p>

          <p className="mt-4 text-center font-semibold">
            महाराष्ट्र राज्य के बुलढाणा जिले में राष्ट्रीय महामार्ग संख्या 161G शेगांव से एम.पी. बॉर्डर (नया राष्ट्रीय
            <p className="text-center font-semibold">
              महामार्ग) पर भूमि का अर्जन</p>
          </p>

          <table className="w-full border border-black mt-6 text-[12px]">
            <thead>
              <tr>
                <th className="border border-black px-2 py-2">क्र. सं.</th>
                <th className="border border-black px-2 py-2">सक्षम प्राधिकारी</th>
                <th className="border border-black px-2 py-2">भूखंड</th>
                <th className="border border-black px-2 py-2">जिला</th>
                <th className="border border-black px-2 py-2">तालुका</th>
                <th className="border border-black px-2 py-2">पुलिस थाना</th>
                <th className="border border-black px-2 py-2">गांव का नाम</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td className="border text-center">1</td>
                <td className="border text-center">
                  उपजिल्हाधिकारी<br />भूसंपादन इ.व.<br />जि.का. बुलढाणा
                </td>
                <td className="border text-center">
                  कि.मी. 55/000 से<br />कि.मी. 118/000
                </td>
                <td className="border text-center">बुलढाणा</td>
                <td className="border text-center">संग्रामपुर</td>
                <td className="border text-center">संग्रामपुर</td>
                <td className="border text-center">वरवट खंडेराव</td>
              </tr>
            </tbody>
          </table>

          <div className="flex justify-between mt-16 text-sm">
            <div>
              <p>उपजिल्हाधिकारी</p>
              <p>भूसंपादन इ.व.</p>
              <p>जि.का. बुलढाणा</p>
            </div>

            <div className="text-right">
              <p>कार्यकारी अभियंता</p>
              <p>राष्ट्रीय महामार्ग विभाग</p>
              <p>अकोला</p>
            </div>
          </div>
        </div>
      </div>

      {showSendToProjectInchargeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4">
            <div className="p-6 space-y-4">

              <label className="text-sm font-medium">
                Select Project Incharge *
              </label>

              <select
                value={selectedUserProjectIncharge}
                onChange={(e) => setSelectedUserProjectIncharge(e.target.value)}
                disabled={loadingUsersProjectIncharge}
                className="w-full p-3 border rounded-lg"
              >
                <option value="">Select User</option>
                {usersProjectIncharge.map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.full_name}
                  </option>
                ))}
              </select>

              <textarea
                value={remarksProjectIncharge}
                onChange={(e) => setRemarksProjectIncharge(e.target.value)}
                rows={3}
                placeholder="Enter remarks"
                className="w-full p-3 border rounded-lg"
              />

              <input
                type="file"
                onChange={(e) => setSelectedDocumentProjectIncharge(e.target.files[0])}
                className="w-full p-3 border rounded-lg"
              />

              <div className="flex justify-end gap-3 pt-4 border-t">
                <button
                  onClick={() => setShowSendToProjectInchargeModal(false)}
                  className="px-4 py-2 border rounded-lg"
                >
                  Cancel
                </button>

                <button
                  onClick={handleSendToProjectIncharge}
                  disabled={sendingToProjectIncharge}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg"
                >
                  {sendingToProjectIncharge ? 'Sending...' : 'Send'}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default SubShakshepAdhikari;
